import type { HttpErrorResponse } from '@angular/common/http';

import { createSingleEntityStore, pipeState } from '@recruitee/ngrx';
import type { RequisitionFormFieldKey, RequisitionsForm } from '@recruitee/requisitions-types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<RequisitionsForm>()(
  'RequisitionsForm',
  {
    customActions: adapter => ({
      update: (state, payload: { fields: RequisitionFormFieldKey[] }) =>
        adapter.markAsPending(state),
      deleteField: (state, payload: { field: RequisitionFormFieldKey }) =>
        adapter.markAsPending(state),
      deleteFieldSuccess: (state, payload: RequisitionsForm) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      deleteFieldFailed: (state, payload: { error: HttpErrorResponse }) =>
        pipeState(state, next => adapter.setError(next, payload.error)),
    }),
  },
);

export {
  actions as RequisitionsFormActions,
  selectors as RequisitionsFormSelectors,
  namespace as RequisitionsFormNamespace,
  reducer as RequisitionsFormReducer,
};
